// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import NextLink from 'next/link';
import styled from '@emotion/styled';
import Image from 'presentations/views/components/atoms/Image';
import {
  primary,
  gray01,
  white,
  gray04,
} from 'presentations/views/styles/color';
import {
  fontWeight,
  fontSize,
  zIndex,
  spacing,
  mediaMax,
} from 'presentations/views/styles';
import Progress from '../Progress';
import { Provider } from 'domains/models/account/providerType';

export enum TitleType {
  SignUp = 1,
  Service = 2,
}

interface Props {
  service:
    | Provider.Google
    | Provider.Microsoft
    | Provider.Slack
    | Provider.Facebook
    | Provider.Apple;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick?: any;
  href?: string | null;
  target?: string;
  title?: string;
  className?: string;
  withoutNextLink?: boolean;
  titleType?: TitleType;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const service = props.service.split('.')[0];
  const titleType = props.titleType || TitleType.SignUp;
  const title = props.title || t(`${service} signup ${titleType}`);
  const renderButton = (
    <BaseButton
      href={props.href || undefined}
      target={props.target}
      className={props.className}
      onClick={props.isDisabled ? null : props.onClick}
      isLoading={props.isLoading}
    >
      {props.isDisabled && <Disabled />}
      {props.isLoading ? (
        <Progress size={20} color="inherit" />
      ) : (
        <>
          <LogoContainer>
            <Logo
              width={16}
              height={16}
              src={`account/${service}.svg`}
              alt={t(service)}
            />
          </LogoContainer>
          <Label>{title}</Label>
        </>
      )}
    </BaseButton>
  );

  return typeof props.href === 'string' && !props.withoutNextLink ? (
    <NextLink href={props.href} passHref>
      {renderButton}
    </NextLink>
  ) : (
    renderButton
  );
}

const BaseButton = styled.a<{ isLoading?: boolean }>`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: ${({ isLoading }) => (isLoading ? 'center' : 'flex-start')};
  padding: ${spacing(8)};
  padding-right: ${spacing(16)};
  min-width: 140px;
  border: 1px solid ${gray04};
  border-radius: 50px;
  background: ${white};
  :hover {
    border: 1px solid ${primary};
  }
`;
const Disabled = styled.div`
  position: absolute;
  z-index: ${zIndex(100)};
  background: ${white};
  opacity: 0.3;
  min-width: 140px;
  height: 100%;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${spacing(4)};
  width: 24px;
  overflow: hidden;
`;
const Logo = styled(Image)``;
const Label = styled.span`
  color: ${gray01};
  font-size: ${fontSize(12)};
  font-weight: ${fontWeight('bold')};
  letter-spacing: -0.02em;
  flex: 1;

  ${mediaMax.tablet} {
    font-size: ${fontSize(10)};
  }
`;
